import { ProviderDate } from '@bagonboard/ui-kit';
import { isDestinationService, SERVICE_TYPES } from '@bagonboard/wiseman';
import PropTypes from 'prop-types';
import { pathOr } from 'ramda';
import React from 'react';

import getAddress from '../../../../../modules/getAddress';
import { Address, Container, Text } from './style';

const Pickup = ({
  original: {
    areas, flightInfo = {}, from, type,
  }, value,
}) => {
  const [{ timezone }] = areas;
  const { city, street } = getAddress(from) || {};
  let addressToShow;

  if (isDestinationService(type)) {
    const { destination: { airportCode, terminal } = {} } = flightInfo;
    addressToShow = `${airportCode} ${terminal ? `Terminal ${terminal.number}` : 'No terminal'}`;
  } else {
    addressToShow = `${street}, ${city}`;
  }

  return (
    <Container>
      <Text>{ProviderDate.timezoneVerbose(value, timezone, 'HH:mm - DD/MM/YYYY')}</Text>
      <Address href={`https://www.google.com/maps/search/${addressToShow}`} target="_blank">
        {addressToShow}
      </Address>
    </Container>
  );
};

Pickup.propTypes = {
  classes : PropTypes.shape({}).isRequired,
  original: PropTypes.shape({
    areas     : PropTypes.array,
    flightInfo: PropTypes.shape({}),
    from      : PropTypes.shape({
      terminal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
    type: PropTypes.string,
  }),
  value: PropTypes.string,
};

Pickup.defaultProps = {
  original: {},
  value   : '',
};

export default Pickup;
